import { render, staticRenderFns } from "./IXAVYZJA.vue?vue&type=template&id=321540c2&scoped=true"
import script from "./IXAVYZJA.vue?vue&type=script&lang=js"
export * from "./IXAVYZJA.vue?vue&type=script&lang=js"
import style0 from "./IXAVYZJA.vue?vue&type=style&index=0&id=321540c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321540c2",
  null
  
)

export default component.exports